import {
  SPARK_BUILDER_ROUTE_REGEX,
  SPARK_RUN_ROUTE_REGEX,
  SPARK_RUN_DETAILS_ROUTE_REGEX,
  BOARDS_ROUTE_REGEX,
} from 'constants/regex';
import React from 'react';
import { useLocation } from 'react-router-dom';

export const useCurrentRoute = () => {
  const location = useLocation();
  const pathName = location.pathname;
  // TEST: to make decisions on various routs, we need to know the current active route
  // we will create an object with each key as a route and value as a boolean
  const routeMap = React.useMemo(() => {
    return {
      isSparkBuilder: SPARK_BUILDER_ROUTE_REGEX.test(pathName),
      isSparkRun: SPARK_RUN_ROUTE_REGEX.test(pathName),
      isSparkRunDetails: SPARK_RUN_DETAILS_ROUTE_REGEX.test(pathName),
      isBoardRoute: BOARDS_ROUTE_REGEX.test(pathName),
      isMemoryDialog: pathName.includes('memory'),
    };
  }, [pathName]);
  return {
    ...location,
    ...routeMap,
  };
};
